import { formatDate } from '@tracsis/library/lib/helpers';
import {
	ArrowRight,
	Download,
} from '@tracsis/library/src/components/Icon/index';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import { Image } from '@tracsis/library/src/index';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useContext } from 'react';

import * as styles from './ResourceCard.module.css';

const ResourceCard = ({
	image,
	to,
	last_updated,
	business_unit,
	title,
	type,
	layout,
	file = false,
}: {
	image?: { filename: string; alt: string };
	to: string;
	last_updated: Date;
	business_unit: string;
	title: string;
	type: string;
	layout: 'list' | 'card';
	file?: boolean;
}) => {
	const { variant } = useContext(ThemeContext);

	return file ? (
		<a href={to} className={styles.link}>
			<div
				className={cx(styles.resourceCard, {
					[styles[`${layout}Layout`]]: layout,
				})}
			>
				<div className={styles.header}>
					{business_unit && (
						<p className={cx(styles[variant], styles.businessUnit)}>
							{business_unit}
						</p>
					)}
					{title && <h3>{title}</h3>}
				</div>

				{image && layout === 'card' && (
					<div className={styles.thumbnail}>
						<Image image={`${image.filename}/m/100x100`} alt={image.alt} />
					</div>
				)}

				{type && <div className={styles.type}>{type}</div>}
				{last_updated && (
					<p className={styles.date}>
						Last Updated: <span>{formatDate(last_updated)}</span>
					</p>
				)}
				<div className={cx(styles[variant], styles.arrow)}>
					<Download />
				</div>
			</div>
		</a>
	) : (
		<Link to={to} className={styles.link}>
			<div
				className={cx(styles.resourceCard, {
					[styles[`${layout}Layout`]]: layout,
				})}
			>
				<div className={styles.header}>
					{business_unit && (
						<p className={cx(styles[variant], styles.businessUnit)}>
							{business_unit}
						</p>
					)}
					{title && <h3>{title}</h3>}
				</div>

				{image && layout === 'card' && (
					<div className={styles.thumbnail}>
						<Image image={image.filename} alt={image.alt} />
					</div>
				)}

				{type && <div className={styles.type}>{type}</div>}
				{last_updated && (
					<p className={styles.date}>
						Last Updated: <span>{formatDate(last_updated)}</span>
					</p>
				)}
				<div className={cx(styles[variant], styles.arrow)}>
					<ArrowRight />
				</div>
			</div>
		</Link>
	);
};

export default ResourceCard;
